import { useContext } from "react";

import { ShipmentContext } from "../context/Shipment";

export const useShipmentContext = () => {
  const context = useContext(ShipmentContext);

  return context;
};
